import { UICheapFlightInfo } from "@flights/types";

export type State = UICheapFlightInfo[] | null;

export const getInitialState = (): State => null;
